// extracted by mini-css-extract-plugin
export default {"container":"FhFI9","innerContainer":"dg9j9","title":"Hoa1d","content":"y9cyF","cta":"me3OE"};